import { FUNCTIONS_URL } from "./firebaseConsts"

export const callFirebaseCloudFunction = async <T, D>(name: string, data: D, options?: Partial<{
  headers: Record<string, string>,
  cache: RequestCache,
}>) => {
  const response = await fetch(`${FUNCTIONS_URL}/${name}`, {
    method: 'POST',
    body: data ? JSON.stringify(data) : undefined,
    headers: {
      'Content-type': 'application/json',
      ...(options?.headers ?? {}),
    },
    cache: options?.cache ?? 'default',
  })
  const bodyTxt = await response.text();
  const body = (response.ok && (bodyTxt !== 'OK')) ? JSON.parse(bodyTxt) as T : bodyTxt as T;
  return {
    response, data: body,
  }
}